// Central place for user-provided photo assets. Only user's own photos — no stock.
export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/fbtty7sg_unnamed.webp",
  pitmasterSmoke:
    "https://customer-assets.emergentagent.com/job_1031e0e7-3557-4681-8dcf-d4744ca7c060/artifacts/fnsfbbbc_675464227_819101371240067_6406985448873206462_n.jpg",
  smokerCloseup:
    "https://customer-assets.emergentagent.com/job_1031e0e7-3557-4681-8dcf-d4744ca7c060/artifacts/8e69t46w_741940424_1026461280031520_4168179663440241493_n.jpg",
  teamKcbs:
    "https://customer-assets.emergentagent.com/job_1031e0e7-3557-4681-8dcf-d4744ca7c060/artifacts/zens3fwv_678757772_819102637906607_2484998124153112791_n.jpg",
  brisketShirts:
    "https://customer-assets.emergentagent.com/job_1031e0e7-3557-4681-8dcf-d4744ca7c060/artifacts/mkdgoqg7_556105281_658010620682477_694544269636234473_n.webp",
  // Batch 2 — brand & food photos
  twoGuysLogo:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/2b45jwyx_445552154_327354247081451_8234433124890558427_n.jpg",
  ribsRaw:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/yjjf8uvs_735193420_1373749077994417_5146088850131675540_n.jpeg",
  chickenGlazed:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/4484atym_679786386_819090644574473_7209360388387866863_n.jpg",
  brisketPlate:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/8684uucg_675536977_819089071241297_3709877749533203395_n.jpg",
  team3:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/9nv0yeuy_676785552_819105714572966_1264142247357095431_n.webp",
  // Batch 3 — Catering event photos
  cateringSpread:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/e8b39toj_741265984_1044871451330339_1217400810887598658_n.jpeg",
  cateringBeans:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/v5aleloq_741888778_1741950006940020_8723177596800055237_n.jpeg",
  cateringSides:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/k4ctj18d_741963517_1317135423822131_5434203521175193764_n.jpeg",
  cateringElote:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/4ydjo6uy_742649158_3444237449069987_918432843712762837_n.jpeg",
  cateringPulledPork:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/j4tvr3v1_741360860_1534964844706480_2425667065349312597_n.jpeg",
  // Batch 4 — more catering + product lineup
  cateringMac:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/q36uja76_742145118_2869505090070929_610966422374443424_n.jpeg",
  cateringPotatoSalad:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/zp6kxso3_740052699_1493961625819758_4311614916483302195_n.jpeg",
  cateringBrisket:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/x364dox1_740215590_2641379846257876_6814381981024471537_n.jpeg",
  productsLineup:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/du3lfqxm_740183866_1997162037828024_4788911395446889892_n.jpeg",
  // Batch 5 — Individual product bottles
  productSweetPerfection:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/ttpdqv73_88F73E92-14E6-474A-8FDC-30F74C113FEC.webp",
  productSillyGoose:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/2e23df7o_0BB81C96-7D4A-4336-9088-5FDBD8A71476_07c16503-bd42-4cbe-bed3-1c28f81e71a8.webp",
  productHoneyJalapeno:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/iokvcwvg_71475682-3F05-4A4C-8F8E-9F268181EA78.webp",
  productTillmanBeefRub: "/products/big-moes-kickin-rub.jpg",
  // Menu card artwork — displayed in full color on the Menu page
  menuCard:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/iotwos2o_unnamed%20%288%29.webp",
  // Menu card — reverse side (Sandwiches / By The Pound / Lunch Special / Kids Menu)
  menuCardBack:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/1ydetscz_image.png",
  // Full catering menu card — Meats, Homemade Sides, Recommended Serving Guide
  menuCardCatering:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_richey-bbq-shop/artifacts/d0mxirwx_image.png",
  // Illustrated hand-drawn flying pig — transparent PNG, works on light + dark backgrounds
  flyingPigArt: "/pig/flying-pig.png",
  // Merch
  floridaBrisketTee:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/yy1ewh7y_image.png",
  // WPF Apparel Co. black cap with leather patch — cleaned to pure-white background
  productCap: "/products/wpf-cap.jpg",
  // Silly Goose Club trucker hat — black with cream Silly Goose Club embroidery
  productSillyGooseHat:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_richey-bbq-shop/artifacts/jx9t3mf4_image.png",
  // Holiday Gift Pack — all four rubs in front of the When Pigs Fly wooden sign
  productHolidayGiftPack:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_richey-bbq-shop/artifacts/z76i86cf_image.png",
  productTrio16oz: "/products/trio-16oz.jpg",
  // Rubbin' & Racin' Racing Team tee — background stripped to pure white
  teeRubbinRacin: "/products/tee-racing.png",
  teeRubbinRacinFront: "/products/tee-racing-front.png",
  // BBQ It's a Lifestyle neon pig tee — background stripped to pure white
  teeBbqLifestyle: "/products/tee-lifestyle.png",
  teeBbqLifestyleFront: "/products/tee-lifestyle-front.png",
  // When Pigs Fly BBQ neon sign tee — background stripped to pure white
  teeNeonBbq: "/products/tee-neon-bbq.png",
  teeNeonBbqFront: "/products/tee-neon-bbq-front.png",
  // "We Support Team Felicia" CMT awareness tee — background stripped to pure white
  teeTeamFelicia: "/products/tee-team-felicia.png",
  teeTeamFeliciaFront: "/products/tee-team-felicia-front.png",
  // Sauce bottles
  productChipotleAppleSauce:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/0t5pkmph_image.png",
  productLastCallSauce: "/products/last-call-sauce.jpg",
  productFloridaGoldSauce:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_richey-bbq-shop/artifacts/f1ske6bi_florida.webp",
  productGrandmasRedSauce:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_richey-bbq-shop/artifacts/4a5r3oww_grandma21oz.webp",
  // Retro "Future Locations To Be Determined" hand-painted sign
  futureLocationsSign:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/4zfpldt5_image.png",
  // Family / team group photo at KCS backdrop — About page hero
  familyTeamKcs:
    "https://customer-assets.emergentagent.com/job_richey-bbq-shop/artifacts/nk929y6h_image.png",
};

export const CATERING_PHOTOS = [
  { src: "cateringSpread", alt: "Full-service chafing-dish spread — wedding & private event catering" },
  { src: "cateringBrisket", alt: "Competition brisket sliced by the pan" },
  { src: "cateringPulledPork", alt: "Slow-smoked pulled pork by the pan for events" },
  { src: "cateringMac", alt: "House mac & cheese — full-pan portion for events" },
  { src: "cateringPotatoSalad", alt: "Family-recipe potato salad, paprika-dusted" },
  { src: "cateringBeans", alt: "House baked beans in the chafing dish" },
  { src: "cateringSides", alt: "Homestyle sides with our seasonings on the table" },
];

export const GALLERY = [
  { src: ASSETS.pitmasterSmoke, alt: "Pitmaster tending the smoker" },
  { src: ASSETS.cateringSpread, alt: "Full catering setup with chafing dishes and florals" },
  { src: ASSETS.cateringBrisket, alt: "Competition brisket sliced by the pan" },
  { src: ASSETS.chickenGlazed, alt: "Glazed BBQ chicken thighs" },
  { src: ASSETS.cateringPulledPork, alt: "Pulled pork by the full pan" },
  { src: ASSETS.cateringMac, alt: "House mac & cheese by the pan" },
  { src: ASSETS.smokerCloseup, alt: "Custom smoker with our logo" },
  { src: ASSETS.cateringPotatoSalad, alt: "Family potato salad, paprika-dusted" },
  { src: ASSETS.cateringSides, alt: "Homestyle sides with our sauces on the table" },
  { src: ASSETS.ribsRaw, alt: "Racks of ribs prepped for the pit" },
  { src: ASSETS.cateringElote, alt: "Peach cobbler baked beans in the chafing dish" },
  { src: ASSETS.brisketPlate, alt: "Sliced brisket plate" },
  { src: ASSETS.cateringBeans, alt: "House baked beans in the chafing dish" },
  { src: ASSETS.productsLineup, alt: "Our seasoning & sauce lineup — Last Call, Tillman's Florida Gold, Grandma's Red, Sweet Perfection" },
  { src: ASSETS.teamKcbs, alt: "Family team at KCBS backdrop" },
  { src: ASSETS.brisketShirts, alt: "Loading the pit — Florida Brisket shirts" },
  { src: ASSETS.team3, alt: "The crew after a competition" },
];

export const BUSINESS = {
  name: "When Pigs Fly Family BBQ",
  tagline: "From Our Family to Yours",
  address: "16447 US-41, Spring Hill, FL 34610",
  street: "16447 US-41",
  city: "Spring Hill, FL 34610",
  county: "Pasco County",
  phone: "(727) 427-5327",
  phoneRaw: "+17274275327",
  smsBody: "Hi, I'd like to place an order at When Pigs Fly Family BBQ. My name is:",
  email: "info@whenpigsflyfamilybbq.com",
  toastOrderUrl: "https://order.toasttab.com/online/2-guys-grilling-12718-winners-cir",
  doordashUrl:
    "https://www.doordash.com/store/when-pigs-fly-bbq-spring-hill-38057249/",
  ubereatsUrl:
    "https://www.ubereats.com/store-browse-uuid/663231ab-2139-58b2-a00a-180f51652081?diningMode=DELIVERY",
  ubereatsPromoCode: "eats-14b3pehxhe",
  paypalUrl: "https://www.paypal.biz/2guysgrilling",
  hours: [
    ["Mon", "11:00 AM – 3:00 PM"],
    ["Tue – Sat", "11:00 AM – 8:00 PM"],
    ["Sun", "Closed"],
  ],
  ordering: ["Dine-In", "Takeout", "Catering"],
  socials: {
    facebook: "https://www.facebook.com/2GUYSGRILLING",
    instagram: "https://www.instagram.com/Whenpigsfly2guysgrilling",
    tiktok: "https://tiktok.com/@whenpigsflyfamilybbq",
    youtube: "https://www.youtube.com/@WhenPigsFlyBBQ",
  },
};
